// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { Product, Program } from 'models';

// ui
import { UitkCard, UitkCardContentSection, UitkCardActionArea } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkSecondaryButton, UitkTertiaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

//bernie
import { Viewport, ViewSmall, ViewMedium } from 'bernie-view';

export interface ProductCardProps {
  actions?: boolean;
  l10n?: ILocalization;
  locale: string;
  product: Product;
  program?: Program;
  preview?: boolean;
  pending?: boolean;
}

export const ProductCard: React.FunctionComponent<ProductCardProps> = ({
  actions,
  l10n,
  locale,
  product,
  program,
  preview,
  pending,
}) => {
  let comingSoon: string;
  const title = l10n.formatText(`products.${product.name}.title`);
  const body = l10n.formatText(`products.${product.name}.content`);
  const previewCtaText = l10n.formatText('preview');
  const openCtaText = l10n.formatText('open');
  const guideText = l10n.formatText('products.guide.text');
  const covidCtaText = l10n.formatText('products.covid19.cta.text');
  const isCovidCard = product.name === 'covid19';
  const actionCTAs = (guideLink, link) => (
    <UitkLayoutFlex alignItems="center" justifyContent="start">
      {link && (
        <UitkLayoutFlexItem>
          <UitkSecondaryButton
            href={link}
            text={isCovidCard ? covidCtaText : preview ? previewCtaText : openCtaText}
            tag="a"
            target={product.isExternal ? '_blank' : null}
          />
        </UitkLayoutFlexItem>
      )}
      {guideLink && (
        <UitkLayoutFlexItem>
          <UitkTertiaryButton href={guideLink} text={guideText} tag="a" target="_blank" />
        </UitkLayoutFlexItem>
      )}
    </UitkLayoutFlex>
  );

  if (!product.live) {
    comingSoon = l10n.formatText('common.coming.soon');
  }

  return (
    <UitkCard padded={true} className="Product">
      <UitkCardContentSection>
        <UitkLayoutFlex alignItems="start">
          <UitkLayoutFlexItem>
            <UitkSpacing margin={{ blockstart: 'one', inlineend: 'six' }}>
              <i className="Product__icon" style={{ backgroundImage: `url(../../images/icons/${product.icon}.svg)` }} />
            </UitkSpacing>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <div>
              <div>
                <UitkHeading tag="h3" size={5}>
                  {title}
                </UitkHeading>
                <UitkSpacing margin={{ blockstart: 'one' }}>
                  <UitkText size={300}>{body}</UitkText>
                </UitkSpacing>
              </div>
              {pending && (
                <UitkSpacing margin={{ blockstart: 'four' }}>
                  <UitkText size={300}>
                    {l10n.formatText('products.pending.application.under.review')}
                  </UitkText>
                </UitkSpacing>
              )}
              {actions && product.live && (product.guideLink || product.link) && (
                <UitkSpacing margin={{ blockstart: 'four' }}>
                  <div>{actionCTAs(product.guideLink, product.link)}</div>
                </UitkSpacing>
              )}
              {comingSoon && (
                <UitkSpacing margin={{ blockstart: 'four' }}>
                  <UitkHeading size={6}>{comingSoon}</UitkHeading>
                </UitkSpacing>
              )}
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkCardContentSection>
    </UitkCard>
  );
};
